export default __webpack_public_path__ + "static/media/wizard.8ff974d9.png";